module.exports = __webpack_public_path__ + "static/img/2-11-普通补发建单.4551076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-11-普通补发建单.png
// module id = 1346
// module chunks = 0